import React from "react";
import Routes from "./Routes";

// add staticly fonts used by our css
import "@fontsource/vazirmatn";
import "@fontsource/ibm-plex-sans-arabic";
import "@fontsource/noto-sans-arabic";
import "@fontsource/jetbrains-mono";

function App() {
  return (
    <Routes />
  );
}

export default App;
